import { DetailsPanelButtonState } from '@/types/enums'

export const inboundActionData: any[] = [
  {
    name: 'Review',
    validStatuses: [
      'sent', 'approval_requested'
    ],
    primaryAction: [
      'sent', 'approval_requested'
    ],
    detailsPanel: DetailsPanelButtonState.Hide
  },
  {
    name: 'Approve',
    textColor: 'success',
    validStatuses: [
      'sent', 'approval_requested'
    ],
    primaryAction: [
    ],
    detailsPanel: DetailsPanelButtonState.Expose
  },
  {
    name: 'Pay',
    validStatuses: [
      'approved',
      'partially_paid'
    ],
    primaryAction: [
      'approved',
      'partially_paid'
    ],
    detailsPanel: DetailsPanelButtonState.Expose
  },
  {
    name: 'Forward to Client',
    textColor: 'success',
    validStatuses: [
      'approved',
      'partially_paid',
      'paid'
    ],
    primaryAction: [
    ]
  },
  {
    name: 'Reject',
    textColor: 'error',
    validStatuses: [
      'sent', 'approval_requested'
    ],
    primaryAction: [
    ],
    detailsPanel: DetailsPanelButtonState.Expose
  },
  {
    name: 'Edit',
    validStatuses: [
      'draft', 'sent', 'approval_requested', 'approved', 'rejected'
    ],
    primaryAction: []
  },
  {
    name: 'Save',
    validStatuses: ['draft', 'sent', 'approval_requested', 'approved'],
    primaryAction: [],
    detailsPanel: DetailsPanelButtonState.Only
  },
  {
    name: 'Save And Approve',
    validStatuses: ['unsaved'],
    primaryAction: []
  },
  {
    name: 'Save And Send for Review',
    validStatuses: ['unsaved'],
    primaryAction: []
  },
  {
    name: 'Skip',
    validStatuses: true,
    primaryAction: [
      'Skip'
    ],
    textColor: 'error',
    detailsPanel: DetailsPanelButtonState.Only
  },
  {
    name: 'Save As Draft',
    validStatuses: ['unsaved'],
    primaryAction: []
  },
  {
    name: 'Send for Review',
    validStatuses: ['draft'],
    primaryAction: ['draft'],
    detailsPanel: DetailsPanelButtonState.Expose
  },
  {
    name: 'Save and Resend for Review',
    validStatuses: ['sent'],
    primaryAction: [],
    detailsPanel: DetailsPanelButtonState.Hide
  },
  {
    name: 'Confirm',
    validStatuses: ['sent'],
    textColor: 'success',
    primaryAction: [],
    detailsPanel: DetailsPanelButtonState.Expose
  },
  {
    name: 'Void',
    validStatuses: ['draft', 'sent', 'rejected', 'approved'],
    textColor: 'error',
    primaryAction: [],
    detailsPanel: DetailsPanelButtonState.Expose
  },
  {
    name: 'Resend Confirm & Deny Email',
    validStatuses: ['sent', 'approval_requested'],
    textColor: 'success',
    primaryAction: [],
    detailsPanel: DetailsPanelButtonState.Expose
  }
]

export const actionsToShowNonCompliantVendorAlertFor: string[] = ['approve']
